import React from 'react';

import { ProductFormQuestion } from '@ttstr/api';
import FormField from '@ttstr/components/Form/FormField';

interface OwnProps {
  answerId: number;
  question: ProductFormQuestion;
  defaultValue?: any;
}

type Props = Readonly<OwnProps>;

const QuestionInput: React.FC<Props> = ({ answerId, question, defaultValue }) => {
  switch (question.format) {
    case 'headline':
      return <h5 className="mb-3">{question.title}</h5>;
    case 'boolean':
      return (
        <FormField
          type="checkbox"
          id={String(answerId)}
          name={String(answerId)}
          validationOptions={{ required: question.mandatory }}
          optional={!question.mandatory}
          label={question.title}
          helpText={question.hint}
          defaultValue={defaultValue}
        />
      );
    case 'integer':
      return (
        <FormField
          type="number"
          id={String(answerId)}
          name={String(answerId)}
          validationOptions={{ required: question.mandatory }}
          optional={!question.mandatory}
          label={question.title}
          helpText={question.hint}
          defaultValue={defaultValue}
        />
      );
    case 'date':
      return (
        <FormField
          type="date"
          id={String(answerId)}
          name={String(answerId)}
          validationOptions={{ required: question.mandatory }}
          optional={!question.mandatory}
          label={question.title}
          helpText={question.hint}
          defaultValue={defaultValue}
        />
      );
    case 'text':
      return (
        <FormField
          type="textarea"
          id={String(answerId)}
          name={String(answerId)}
          validationOptions={{ required: question.mandatory }}
          optional={!question.mandatory}
          label={question.title}
          helpText={question.hint}
          maxLength={question.character_limit}
          defaultValue={defaultValue}
        />
      );
    case 'select': // fall-through
    case 'multiselect':
      return (
        <FormField
          type="select"
          id={String(answerId)}
          name={String(answerId)}
          validationOptions={{ required: question.mandatory }}
          optional={!question.mandatory}
          label={question.title}
          helpText={question.hint}
          multiple={question.format === 'multiselect'}
          defaultValue={defaultValue}
        >
          {question.options_for_select.map((value) => (
            <option key={value} value={value}>
              {value}
            </option>
          ))}
        </FormField>
      );
    case 'product':
      return (
        <FormField
          type="select"
          id={String(answerId)}
          name={String(answerId)}
          validationOptions={{ required: question.mandatory }}
          optional={!question.mandatory}
          label={question.title}
          helpText={question.hint}
          defaultValue={defaultValue}
        >
          {question.options_for_select.map(({ id, title }) => (
            <option key={id} value={id}>
              {title}
            </option>
          ))}
        </FormField>
      );

    case 'string': // fall-through
    default:
      return (
        <FormField
          type="text"
          id={String(answerId)}
          name={String(answerId)}
          validationOptions={{ required: question.mandatory }}
          optional={!question.mandatory}
          label={question.title}
          helpText={question.hint}
          maxLength={question.character_limit}
          defaultValue={defaultValue}
        />
      );
  }
};

export default React.memo(QuestionInput);
